import { render } from "./my.login.popup.vue?vue&type=template&id=b64b5658"
import script from "./my.login.popup.vue?vue&type=script&lang=js"
export * from "./my.login.popup.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/tractus.web.clientapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__